<template lang="pug">
    article.b-card.-faq.-no-top-radius(style="border-top:none" :class="{collapse:!bannerVisible}")
        b-btn.btn-close(variant="outline" size="sm" @click="bannerVisible = false")
        ._title.header-3.mb-4.text--blue Connections — b2b-сервис для юридического рынка
        ._content
            p Сегодня Право.ru видит свою миссию в создании платформы для партнерского взаимодействия и сохранения здоровой конкуренции. Раздел Connections — b2b-сервис для юридического рынка. В профильном СМИ ваши запросы и отклики будут точно по адресу.<br>
            p
                b Как опубликовать Connection?

            b-collapse#faq-collapse(v-model="readMoreVisible")
                p Просто пришлите нам заявку на connections@pravo.ru в такой форме:
                ul(style="font-size:15px;")
                    li Название компании/краткое описание компании
                    li Запрос на развитие практики/предложение о партнерстве/объявление о поиске подрядчика на проект/вакансию/информацию о тендере
                    li Основные критерии выбора, требования, другие важные детали
                    li Условия
                    li Контакты для связи
        b-btn.label-3.fw-bold.mt-4.p-0(variant="outline" v-b-toggle.faq-collapse) {{ readMoreVisible ? 'Свернуть' : 'Подробнее'}}
</template>

<script>
import Card from "@/components/CardComponent.vue";

export default {
    name: "FAQComponent",
    components: { Card },
    data: () => ({
        readMoreVisible: false,
    }),
    computed: {
        bannerVisible: {
            get() {
                return this.$store.state.FAQisVisible;
            },
            set(val) {
                this.$store.commit("setFAQstate", val);
            },
        },
    },
};
</script>

<style lang="scss">
.card--faq {
    margin-top: -1rem;
    margin-bottom: 1rem;

    .btn-close {
        position: absolute;
        top: 12px;
        right: 24px;
    }

    @media (min-width: 767.98px) {
        margin-top: -2rem;

        .btn-close {
            position: absolute;
            top: 12px;
            right: 12px;
        }
    }
}
</style>
